/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { RefObject, useState } from 'react'
import { Field, Form, Formik, FormikProps } from 'formik'
import styled from 'styled-components'
import { DateTime } from 'luxon'
import * as Yup from 'yup'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Form as NXUIForm } from '@nexigendigital/nxui'
import { useSavePaymentMethodMutation } from 'api/billing'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    form: RefObject<FormikProps<{ cardholder: string, cardNumber: string, expiry: string }>>
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function NewPaymentMethodForm({ form }: Props) {
    const [savePaymentMethod] = useSavePaymentMethodMutation()
    const [defaultPayment, setDefaultPayment] = useState(false)

    return (
        <Formik
            innerRef={form}
            initialValues={{
                cardholder: '',
                cardNumber: '',
                expiry: ''
            }}
            validationSchema={Yup.object({
                cardholder: Yup.string()
                    .required('Required'),
                cardNumber: Yup.string()
                    .required('Required'),
                expiry: Yup.string()
                    .required('Required')
            })}
            onSubmit={({ cardholder, cardNumber, expiry }) => {
                savePaymentMethod({
                    expiry,
                    card_holder: cardholder,
                    card_number: cardNumber,
                    is_default: defaultPayment
                })
            }}
        >
            {({ isSubmitting }) => (
                <Form className={'form'}>
                    <Field
                        label={'Cardholder Name'}
                        name={'cardholder'}
                        type={'text'}
                        disabled={isSubmitting}
                        component={NXUIForm.InputField}
                    />
                    <Field
                        label={'Card Number'}
                        name={'cardNumber'}
                        type={'text'}
                        component={NXUIForm.InputField}
                    />
                    <Field
                        label={'Expiration Date'}
                        name={'expiry'}
                        type={'text'}
                        placeholder={`${DateTime.local().plus({ year: 2 }).year}-12`}
                        disabled={isSubmitting}
                        component={NXUIForm.InputField}
                    />
                    <Toggle>
                        <label htmlFor="">Set as primary</label>
                        <NXUIForm.Switch checked={defaultPayment} onClick={() => {
                            setDefaultPayment(!defaultPayment)
                        }}/>
                    </Toggle>
                </Form>
            )}
        </Formik>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const Toggle = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`
